import { useLanguage } from "@/hooks/useLanguage";

export default function PrivacyPage() {
  const { language } = useLanguage();
  const t = (it: string, es: string, en: string) => (language === 'es' ? es : language === 'en' ? en : it);
  return (
    <div className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-2xl font-semibold mb-4">{t('Privacy Policy', 'Política de Privacidad', 'Privacy Policy')}</h1>
      <p className="mb-2 text-white/90">
        {t(
          'Questa pagina descrive come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali in conformità al GDPR.',
          'Esta página describe cómo recopilamos, utilizamos y protegemos sus datos personales de acuerdo con el RGPD.',
          'This page describes how we collect, use and protect your personal data in compliance with GDPR.'
        )}
      </p>
      <p className="text-white/90">
        {t(
          'Per richieste o revoca del consenso, utilizza il pulsante “Gestisci cookie” o contattaci.',
          'Para solicitudes o revocación del consentimiento, use el botón “Gestionar cookies” o contáctenos.',
          'For requests or revoking consent, use the “Manage cookies” button or contact us.'
        )}
      </p>
    </div>
  );
}